import { RoomPropertyEnum } from "./NavbarList";

export const roomDefinitionValues = {
  isCotNotAllowed: false,
  isCribNotAllowed: false,
  ownershipType: "None",
  isBedded: true,
  isNoAutoPostRoomAndTax: false,
  roomsForOccupancyTax: false,
  suiteRoomCodes: [],
  blockingOrder: 0,
  floor: 0,
  energySection: 0,
  keyNumber: 0,
  licenseFromDate: new Date().toISOString().split("T")[0],
  licenseToDate: new Date(new Date().setFullYear(new Date().getFullYear() + 5))
    .toISOString()
    .split("T")[0],
  physicalAddress: "",
  lastDecorated: new Date().toISOString().split("T")[0],
  matressTurned: new Date().toISOString().split("T")[0],
  roomStatus: "V",
};

export const payloadConstants = {
  [RoomPropertyEnum.roomTypeMaintainence]: {
    NO_OF_ROOMS: 0,
    MAX_GUESTS: 0,
    MAX_NIGHTS: 0,
    RESORT_FEE: 0,
    RESORT_FEE_TYPE: "Flat",
    FEE_FREQUENCY: "daily",
    VILLA_HOME_TEMPLATE_CODE: "VIllaTemplate1",
    POST_TYPE_NAME: "",
    COUNT_ROOM_AS: 0,
    TYPE: "None",
    LICENSE_FROM_DATE: new Date().toISOString().split("T")[0],
    LICENSE_TO_DATE: new Date(
      new Date().setFullYear(new Date().getFullYear() + 5),
    )
      .toISOString()
      .split("T")[0],
  },
  [RoomPropertyEnum.roomDefinitions]: {
    ROOM_DESCRIPTION: "Room Description",
    BED_COUNT: 0,
    STAYOVER_POINTS: 0,
    CHECKOUT_POINTS: 0,
    HOUSEKEEPING_POINTS: 0,
    CONDO_DESCRIPTION: "Condo Description",
    CONDO_FIRST_NAME: "",
    CONDO_LAST_NAME: "",
    CONDO_ROOM_REVENUE: 0,
    CONDO_UNIT_CONDITION: "",
    CONDO_ADDRESS: "",
    CONDO_CONTACT_DETAILS: "",
  },
  [RoomPropertyEnum.postTypes]: {
    CHARACTERISTICS: "Debit",
    POST_TYPE_CATEGORY: "Revenue",
    DEFAULT_AMOUNT: 0,
    FLOOR_LIMIT: 0,
    CEILING_LIMIT: 0,
    DEFAULT_FOLIO: 1,
    DEFAULT_MASTER_FOLIO: 1,
    LEDGER_NUMBER: "",
    SAGE_EXTRACT_NUMBER: "",
    EXTRACT_REVENUE_BRACKET: "",
    COMMISSIONPERCENTAGE: "",
  },
  [RoomPropertyEnum.PaymentMethods]: {
    POST_TYPE_NUMBER: 0,
    CREDIT_LIMIT: 0,
    CENTRAL_RESERVATION: "",
    PHONE_RESTRICTIONS: 0,
  },
};
